import { EWorldMapSetType } from '__generated__/globalTypes';
import { ActionButton } from 'elements/eventView/atomic/ActionButton';
import { useAnalytics } from 'libs/utils/site/analytics';
import { intersection, sortBy } from 'lodash';
import { useContext, useEffect } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    newMarkerId: string;
}

export const FloorsFilter = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { setVisibleFloorIds } = ctxEventView;
    const analytics = useAnalytics();
    const isWide = ctxEventView.isWide;

    const floors = sortBy(
        ctxEventView.rawGraphQLData.map?.worldMapSets?.filter(
            (e) => e.type === EWorldMapSetType.FLOOR
        ) ?? [],
        (e) => e.orderIndex
    );

    const newMarkerId = props.newMarkerId;

    useEffect(() => {
        if (!newMarkerId) {
            return;
        }

        if (floors && floors.length) {
            const visibleFloorIds = floors
                .filter((e) => ctxEventView.visibleFloorIds.includes(e.worldMapSetId))
                .map((e) => e.worldMapSetId);
            const floorIdsWithMarker = floors
                .filter((e) => e.markers.some((m) => m.worldMapMarkerId === newMarkerId))
                .map((e) => e.worldMapSetId);

            if (!floorIdsWithMarker?.length) {
                return;
            }
            if (intersection(visibleFloorIds, floorIdsWithMarker).length === 0) {
                setVisibleFloorIds([floorIdsWithMarker[0]]);
            }
        }
    }, [newMarkerId]);

    function handleClick(id: string, title: string) {
        analytics.track('event_ui.filter.clicked', {
            id,
            title,
            type: 'floor'
        });

        setVisibleFloorIds([id]);
    }

    return (
        <S_FloorsFilter $isWide={isWide}>
            {floors.map((floor) => {
                return (
                    <S_ActionButton
                        key={floor.worldMapSetId}
                        icon={{ iconSet: 'fal', iconName: 'layer-group' }}
                        text={floor.title}
                        highlighted={ctxEventView.visibleFloorIds?.includes(floor.worldMapSetId)}
                        onClick={() => {
                            handleClick(floor.worldMapSetId, floor.title);
                        }}
                    />
                );
            })}
        </S_FloorsFilter>
    );
};

const S_FloorsFilter = styled.div<{ $isWide: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: all;
    ${(props) => {
        if (props.$isWide) {
            return css`
                margin-top: 10px;
            `;
        }
    }}
`;

const S_ActionButton = styled(ActionButton)``;
